import state from "@/store/modules/dashboard-box/state";
import actions from "@/store/modules/dashboard-box/actions";
import mutations from "@/store/modules/dashboard-box/mutations";
import getters from "@/store/modules/dashboard-box/getters";

export default {
    state,
    actions,
    mutations,
    getters
}